(() => {
  const root = document.querySelector('[data-ud-root]');
  if (!root) return;

  const panel = root.querySelector('[data-ud-panel]');
  const titleEl = root.querySelector('[data-ud-title]');
  const bodyEl = root.querySelector('[data-ud-body]');
  if (!panel || !titleEl || !bodyEl) return;

  let lastFocused = null;

  // For moving content back on close
  let movedNode = null;
  let movedNodePlaceholder = null;

  function lockScroll(lock) {
    document.documentElement.classList.toggle('ud-lock', lock);
    document.body.classList.toggle('ud-lock', lock);
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') close();
  }

  function restoreMovedContent() {
    if (!movedNode || !movedNodePlaceholder || !movedNodePlaceholder.parentNode) return;

    movedNode.style.display = 'none';
    movedNodePlaceholder.parentNode.replaceChild(movedNode, movedNodePlaceholder);

    movedNode = null;
    movedNodePlaceholder = null;
  }

  function open({ title } = {}) {
    if (typeof title === 'string') titleEl.textContent = title;

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    lockScroll(true);

    lastFocused = document.activeElement;
    requestAnimationFrame(() => panel.focus());

    document.addEventListener('keydown', onKeyDown);
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    lockScroll(false);

    document.removeEventListener('keydown', onKeyDown);

    restoreMovedContent();

    // Restore focus
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function clearBody() {
    restoreMovedContent();
    bodyEl.innerHTML = '';
  }

  // Execute scripts inside a container by recreating them
  // (scripts added via innerHTML won’t run; recreated ones will)
  function runScripts(container) {
    const scripts = container.querySelectorAll('script');
    scripts.forEach(oldScript => {
      const newScript = document.createElement('script');

      // Copy attributes (type, src, etc.)
      for (const attr of oldScript.attributes) {
        newScript.setAttribute(attr.name, attr.value);
      }

      // Inline script
      if (!oldScript.src) {
        newScript.textContent = oldScript.textContent;
      }

      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-ud-open]');
    const closer = e.target.closest('[data-ud-close]');

    if (closer) {
      close();
      return;
    }

    if (!opener) return;
    if (opener.tagName === 'A') e.preventDefault();

    const title = opener.getAttribute('data-ud-title') || 'Panel';

    const moveSelector = opener.getAttribute('data-ud-move');
    const contentSelector = opener.getAttribute('data-ud-content');
    const inlineHtml = opener.getAttribute('data-ud-html');

    clearBody();

    if (moveSelector) {
      const node = document.querySelector(moveSelector);
      if (!node) {
        bodyEl.innerHTML = `<p>Content not found: ${moveSelector}</p>`;
      } else {
        // Create placeholder to restore later
        movedNodePlaceholder = document.createComment('ud-placeholder');
        node.parentNode.replaceChild(movedNodePlaceholder, node);

        // Show it when in drawer
        node.style.display = '';
        bodyEl.appendChild(node);

        movedNode = node;

        if (!node.dataset.udInitialized) {
          runScripts(node);
          node.dataset.udInitialized = 'true';
        }
      }
      open({ title });
      return;
    }

    // Fallback: old behavior (HTML copy) - will NOT run scripts
    if (inlineHtml) {
      bodyEl.innerHTML = inlineHtml;
      open({ title });
      return;
    }

    if (contentSelector) {
      const src = document.querySelector(contentSelector);
      bodyEl.innerHTML = src ? src.innerHTML : `<p>Content not found: ${contentSelector}</p>`;
      open({ title });
      return;
    }

    open({ title });
  });

  // Optional public API
  window.UniversalDrawer = { open, close };
})();
